import React, {useEffect, useState} from 'react';
import _ from "lodash";
import DesignSyncFilters from "./design-sync-filters";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {DESIGN_SYNC_FIELDS_LIST} from "../../constants/design-sync.constant";
import {searchDesignSyncsWithSearchCriteria, updateSingleDesignSync} from "./design-sync-data.service";
import {showDateTime} from "../../../printful/utils/printful-util";
import {
    bulkUpdateDesignContent,
    initiateShopifyProductPriceSync
} from "../../../common/services/cloud-function-service";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";


const defaultFilterCriteria: any = {};

const DesignSyncsList = () => {
    const [designSyncsList, setDesignSyncsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getDesignSyncList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({
                    field: attribute,
                    condition: '==',
                    value: value
                });
            }
        });

        const designSyncListResult = await searchDesignSyncsWithSearchCriteria(searchCriteriaList);

        _.forEach(designSyncListResult, (designSync) => {
            let completedCount = 0;
            let inCompletedCount = 0;
            _.forEach(designSync.designIds, (designId) => {
                if (designSync?.contentStatus && designSync?.contentStatus[designId] === 'COMPLETED') {
                    completedCount++;
                } else {
                    inCompletedCount++;
                }
            });

            designSync.complete = completedCount;
            designSync.inComplete = inCompletedCount;
        });

        // console.log('designSyncListResult', designSyncListResult);

        setDesignSyncsList(designSyncListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getDesignSyncList();
    }, [filterCriteria]);

    const refreshDesignSyncList = async () => {
        await getDesignSyncList();
    }

    const startDesignSyncProcessCloudFunction = async (designSyncId) => {
        setDataFetchInProgress(true);
        await bulkUpdateDesignContent(designSyncId);

        await refreshDesignSyncList();
        setDataFetchInProgress(false);
    }

    const startDesignSyncProcess = async (designSync) => {
        setDataFetchInProgress(true);

        designSync.status = 'STARTED';
        await updateSingleDesignSync(designSync);

        await refreshDesignSyncList();
        setDataFetchInProgress(false);
    }


    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Design Sync
                    </div>

                    {/*<DesignSyncFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    <div className="">
                        <button
                            className="button-green-outline px-4 py-2 flex items-center justify-center"
                            onClick={refreshDesignSyncList}>
                            <span>Refresh</span>
                            <span className="ml-1">
                                <ShowProgressSpinner
                                    sizeClass={'w-5 h-5'}
                                    dataFetchInProgress={dataFetchInProgress}/>
                            </span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={designSyncsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Design Syncs'}/>

                    {designSyncsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {DESIGN_SYNC_FIELDS_LIST?.map((designSyncField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${designSyncField?.cssClass}`}>{designSyncField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {designSyncsList?.map((designSync, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {DESIGN_SYNC_FIELDS_LIST?.map((designSyncField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${designSyncField?.cssClass}`}>
                                                {designSyncField?.optionsMap &&
                                                    <>{designSyncField?.optionsMap[designSync[designSyncField?.attribute]]?.name}</>
                                                }

                                                {!designSyncField?.optionsMap &&
                                                    <>
                                                        {!designSyncField?.isDate &&
                                                            <>
                                                                {designSync[designSyncField?.attribute]}
                                                            </>
                                                        }

                                                        {designSyncField?.isDate &&
                                                            <>
                                                                {showDateTime(designSync[designSyncField?.attribute])}
                                                            </>
                                                        }

                                                        {designSyncField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {designSync[designSyncField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-64">
                                        <div className="flex justify-center items-center">
                                            {((designSync?.status === 'NEW' && designSync?.total > 0) || designSync?.inComplete > 0) &&
                                                <div className="">
                                                    <button
                                                        className="button-green px-4 py-1"
                                                        onClick={() => {
                                                            startDesignSyncProcess(designSync)
                                                        }}>
                                                        <span>Start Design Sync Process</span>
                                                    </button>
                                                </div>
                                            }

                                            <div className="flex justify-around">
                                                <CopyDataToClipboard value={JSON.stringify(designSync, null, 2)}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default DesignSyncsList
